/*globals $ */
import once from 'lodash/once';

const callrequest = {
  /**
   * Init engine. Wrapped in lodash once to make sure it's not called repeatedly
   */
  init: once(() => {
    callrequest.initPopUp();
  }),
  /**
   * Init for binding events
   */
  initPopUp: () => {
    document.querySelectorAll('.auto-callback-div').forEach(container => {
      const openbutton = container.querySelector('.auto-callback-button');
      openbutton.addEventListener('click', callrequest.togglePopUp);
    });

    document.querySelectorAll('.popup-overlay-callrequest').forEach(container => {
      const closebutton = container.querySelector('.popup-close-callrequest');
      closebutton.addEventListener('click', callrequest.closePopUp);
    });

  },
  /**
   * Toggle event for call request links
   * @param  {event} e events
   */
  togglePopUp: e => {
    e.preventDefault();
    document.querySelector('.popup-overlay-callrequest').classList.add('visible');
    document.querySelector('.popup-overlay-callrequest').classList.remove('hidden')
    document.body.classList.add('overlay-open');
  },

  /**
   * Hide call request pop up
   * @param  {event} e events
   */
  closePopUp: e => {
    e.preventDefault();
    document.querySelector('.popup-overlay-callrequest').classList.add('hidden');
    document.querySelector('.popup-overlay-callrequest').classList.remove('visible')
    document.body.classList.remove('overlay-open');
  },
};

export default callrequest;
